import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  recepientsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px',
    boxShadow: '0px 3px 9px #0000001C',
    cursor: 'pointer',
  },
  empty: {
    cursor: 'default',
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  btn: {
    minWidth: 'auto',
    padding: 2,
    background: 'transparent',
    borderRadius: '50%',
  },
  icon: {
    fontSize: '1.5rem',
    color: '#666',
  },
  label: {
    marginLeft: '5px',
  },
  arrowIcon: {
    fontSize: 20,
    color: theme.custom.darkBlue,
  },
  activeArrowIcon: {
    transform: 'rotate(180deg)',
  },
}));
